const BASE_URL = process.env.REACT_APP_API_BASE_URL; 

const getAuthHeaders = () => {
    const token = sessionStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
};

// Function for Calling Submit WhatsApp Chat API
export const submitWhatsAppChatData = async (formData) => {
    const headers = getAuthHeaders(); 

    try {
        const response = await fetch(`${BASE_URL}/customer/submit-whats-app-chat`, {
            method: 'POST',
            body: formData,
            headers: {
                ...headers,
            },
        });

        return await response.json();
    } catch (error) {
        //console.error(error);
        throw error;
    }
};

//Function for Call Get WhatsApp Chat Template Api 
export const getWhatsAppChatTempList = async () => {
    const headers = getAuthHeaders(); 
    try {
        const response = await fetch(`${BASE_URL}/customer/whats-app-chat-template-list`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Something went wrong');
        }

        return data; 
    } catch (error) {
        throw error;
    }
};


//Function for Calling Update WhatsApp Chat Template Name
export const updateWhatsAppChatTempName = async (payload) => {
    const headers = getAuthHeaders(); 

    try {
        const response = await fetch(`${BASE_URL}/customer/update-whats-app-chat-template-name`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(payload),
        });

        return await response.json();
    } catch (error) {
        //console.error(error);
        throw error;
    }
};



//Function for Calling Delete WhatsApp Chat Template
export const deleteWhatsAppChatTemp = async (payload) => {
    const headers = getAuthHeaders(); 

    try {
        const response = await fetch(`${BASE_URL}/customer/delete-whats-app-chat-template`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(payload),
        });

        return await response.json();
    } catch (error) {
        //console.error(error);
        throw error;
    }
};

// Function for Calling Get Single Template Detail API
export const getTemplateDetail = async (id) => {
    const headers = getAuthHeaders(); 

    try {
        const response = await fetch(`${BASE_URL}/customer/whats-app-chat-template-detail?template_id=${id}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                ...headers,
            }
        });

        return await response.json();
    } catch (error) {
        //console.error(error);
        throw error;
    }
};

//Function for Calling Update Template Detail API
export const updateTemplateDetail = async (formData) => {
    const headers = getAuthHeaders(); 

    try {
        const response = await fetch(`${BASE_URL}/customer/update-whats-app-chat-template-detail`, {
            method: 'POST',
            body: formData,
            headers: {
                ...headers,
            },
        });

        return await response.json();
    } catch (error) {
        //console.error(error);
        throw error;
    }
};